import React from "react";
import { stackList } from "../../data/ProjectData";
import {
  Image,
  Technologies,
  Tech,
  TechImg,
  TechName,
  ContactWrapper,
} from "./AboutElements";
// import ScrollAnimation from "react-animate-on-scroll";
function About() {
  return (
    <ContactWrapper id="about">
      <div className="Container">
        <div className="SectionTitle">About Me</div>
        <div className="BigCard">
          {/* <ScrollAnimation animateIn="fadeInLeft"> */}
          {/* <Image
            src="/man-svgrepo-com.svg"
            alt="man-svgrepo"
          /> */}
          {/* </ScrollAnimation> */}
          <div className="AboutBio">
            {/* <ScrollAnimation animateIn="fadeInLeft"> */}


            Hello!
            <br /><br />

            I’m a software engineer specializing in game development. Since entering the industry in 2021, I released 2 games and released several patches for both new and old projects!
            <br /><br />

            My programming journey began when I studied at the upper secondary school, Ljud och Bildskolan, where I grew to love programming and problem solving.
            <br /><br />

            After LBS, I continued my programming studies at The Game Assembly. Throughout my time there, I worked on eight different projects, taking each one from the planning stage all the way to a downloadable game on itch.io.
            At TGA, I also studied courses such as C++, C#, Graphics Programming, AI, Linear Algebra, and Network Programming.
            <br /><br />

            I began my career with an internship at Illusion Labs, which lead to an full-time position. I quit in mid 2025 and are currently working with at a Startup!

            <br /><br />




            <strong>Want to get in touch?</strong>
            <br />
            Send me an email at <a href="mailto:markusjnilsson@hotmail.com">markusjnilsson@hotmail.com</a> or ping me on LinkedIn!


            {/* <div className="tagline2">
              I have become confident using the following technologies:
            </div> */}
            {/* </ScrollAnimation> */}


            {/* <Technologies>
              {stackList.map((stack, index) => (
                // <ScrollAnimation animateIn="fadeInLeft" key={index}>
                <Tech key={index} className="tech">
                  <TechImg src={stack.img} alt={stack.name} />
                  <TechName>{stack.name}</TechName>
                </Tech>
                // </ScrollAnimation>
              ))}
            </Technologies> */}
          </div>

        </div>
      </div>

    </ContactWrapper >


  );
}

export default About;


/*



*/